// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1ServerPool
 */
export interface V1ServerPool {
  /**
   *
   * @type {string}
   * @memberof V1ServerPool
   */
  modeLabel?: string;
  /**
   *
   * @type {string}
   * @memberof V1ServerPool
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof V1ServerPool
   */
  numDesiredInstances?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof V1ServerPool
   */
  serverNames?: Array<string>;
}

/**
 * Check if a given object implements the V1ServerPool interface.
 */
export function instanceOfV1ServerPool(value: object): value is V1ServerPool {
  return true;
}

export function V1ServerPoolFromJSON(json: any): V1ServerPool {
  return V1ServerPoolFromJSONTyped(json, false);
}

export function V1ServerPoolFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ServerPool {
  if (json == null) {
    return json;
  }
  return {
    modeLabel: json['ModeLabel'] == null ? undefined : json['ModeLabel'],
    name: json['Name'] == null ? undefined : json['Name'],
    numDesiredInstances:
      json['NumDesiredInstances'] == null
        ? undefined
        : json['NumDesiredInstances'],
    serverNames: json['ServerNames'] == null ? undefined : json['ServerNames'],
  };
}

export function V1ServerPoolToJSON(json: any): V1ServerPool {
  return V1ServerPoolToJSONTyped(json, false);
}

export function V1ServerPoolToJSONTyped(
  value?: V1ServerPool | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ModeLabel: value['modeLabel'],
    Name: value['name'],
    NumDesiredInstances: value['numDesiredInstances'],
    ServerNames: value['serverNames'],
  };
}
